import { render, staticRenderFns } from "./StoryProduct.vue?vue&type=template&id=1f86ff3c&"
import script from "./StoryProduct.vue?vue&type=script&lang=js&"
export * from "./StoryProduct.vue?vue&type=script&lang=js&"
import style0 from "./StoryProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAutocomplete,VCheckbox,VIcon})
